import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { changeLanguage, changePassword, getLanguages } from '../../store/actions/settingAction';
import { useEffect, useState } from 'react';
import { getContentKeyAccToLang, showToast } from '../../utils/utils';
import { setFetchedClient } from '../../store/slices/investmentsSlice';
import { initiateKyc } from '../../store/actions/corporateAction';
import {
  setClientApplicantId,
  setClientApplicationId,
  setCompanyId,
  setRejectionMsg,
  setIsKyc,
  // setApplicantType,
  setKsaCorporate,
} from '../../store/slices/constantSlice';
import { initiateIndKyc } from '../../store/actions/individualAction';
import { getUserDetail, selectAccounts } from '../../store/actions/authActions';
import { getClientData } from '../../store/actions/investmentsAction';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState(false);
  const [switchAccountData, setSwitchAccountData] = useState(null);
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { settingContent, languageLoading } = useSelector((state) => state.content);
  const { settingLoading, languages, passwordLoading } = useSelector((state) => state.setting);
  const { user } = useSelector((state) => state.common);
  const { clientDetails } = useSelector((state) => state.investments);
  const { kyc_loading } = useSelector((state) => state.corporate);

  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const islinkedAccounts = user?.linkedAccounts?.find(
    (account) => account?.clientId === user?.clientId
  );

  const applicantTypeId =
    user?.linkedAccounts?.length && islinkedAccounts
      ? islinkedAccounts?.applicantTypeId
      : user?.applicantTypeId;

  // const type =
  //   Number(applicantTypeId) === 12
  //     ? 'KSA Resident'
  //     : Number(applicantTypeId) === 11
  //       ? 'KSA National'
  //       : Number(applicantTypeId) === 13
  //         ? 'GCC National'
  //         : 'Other National';

  useEffect(() => {
    dispatch(
      getLanguages((val) => {
        setSelectedLanguage(val?.result?.find((item) => item?.id === user?.clientLanguage?.languageId));
      }),
    );
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(settingContent?.web_general_setting?.data?.attributes, key, isArabic);
  };

  const onLanguageSelect = (val) => setSelectedLanguage(val);

  const handleSubmitLanguage = () => {
    if (selectedLanguage) {
      dispatch(
        changeLanguage(selectedLanguage?.id, () => {
          setSelectedLanguage({
            id: selectedLanguage?.id,
            name: selectedLanguage?.name == 'Arabic' ? 'العربية' : 'English',
          });
          dispatch(setFetchedClient(false));
          dispatch(getUserDetail(user))
        }),
      );
    }
  };

  const handleSubmitPassword = (values) => {
    const apiData = {
      oldPassword: values?.old_password,
      newPassword: values?.new_password,
      confirmPassword: values?.confirm_password,
    };
    dispatch(changePassword(apiData, navigate));
  };

  const handleKycUpdate = (isClientClassification) => {
    if (user?.investorTypeId === 2) {
      const apiData = {
        clientId: user?.clientId,
        callWathq: applicantTypeId?.toString() === '1067' ? true : false,
        languageId: isArabic ? 4 : 3,
      };
      dispatch(
        initiateKyc(apiData, (val) => {
          if (val?.success) {
            navigate(isClientClassification ? '/corporate-form?step=5' : '/corporate-form');
            dispatch(setIsKyc(true));
            dispatch(setClientApplicationId(val?.applicationId));
            dispatch(setClientApplicantId(applicantTypeId));
            dispatch(setKsaCorporate(applicantTypeId?.toString() === '1067'));
            dispatch(setCompanyId(user?.companyTypeId));
            dispatch(setRejectionMsg(user?.wmRejectionComments ?? null));
          } else {
            showToast({
              icon: 'error',
              title: val?.responseMessage,
            });
          }
        }),
      );
    } else {
      const payload = {
        purpose: isClientClassification ? 'ClientClassification' : 'KycUpdate',
        languageId: isArabic ? 4 : 3
      }
      dispatch(initiateIndKyc(payload, (val) => {
        if (val?.redirectUrl) {
          window.open(val?.redirectUrl, '_self');
        }
      }))
      // dispatch(
      //   createKycApplication(
      //     {
      //       clientId: user?.clientId?.toString(),
      //       languageId: isArabic ? 4 : 3,
      //     },
      //     (val) => {
      //       if (val?.status) {
      //         navigate(isClientClassification ? '/individual-form?step=6' : '/individual-form');
      //         dispatch(setIsKyc(true));
      //         dispatch(setClientApplicationId(Number(val?.message)));
      //         dispatch(setApplicantType(type));
      //       } else {
      //         showToast({
      //           icon: 'error',
      //           title: val?.responseMessage,
      //         });
      //       }
      //     },
      //   ),
      // );
    }
  };

  const clientId = user?.investorTypeId === 2 ? clientDetails?.clientInformation?.commercialRegistrationNumber : clientDetails?.clientInformation?.nationalIdentificationNumber;
  const vatNumber = clientDetails?.clientInformation?.vatNumber

  const handleSwitchAccount = () => {
    const api_data = {
      targetClientId: switchAccountData?.clientId,
      investorTypeId: switchAccountData?.investorTypeId,
      languageId: isArabic ? 4 : 3,
    }
    dispatch(selectAccounts(api_data, (res) => {
      dispatch(getClientData());
      navigate('/funds/available-funds');
    }))
  }
  const handleOpenModel = (items) => {
    setConfirmModal(true);
    setSwitchAccountData(items);
  }

  const handleCloseModel = () => {
    setConfirmModal(false)
  }

  return {
    isArabic,
    navigate,
    TextWeight,
    settingLoading,
    languageLoading,
    languages,
    passwordLoading,
    selectedLanguage,
    getContentKey,
    onLanguageSelect,
    handleSubmitLanguage,
    handleSubmitPassword,
    clientDetails,
    handleKycUpdate,
    kyc_loading,
    clientId,
    vatNumber,
    user,
    confirmModal,
    setConfirmModal,
    handleOpenModel,
    handleCloseModel,
    handleSwitchAccount,
    direction,
  };
};
